import type { SepaDirectDebit } from './SepaDirectDebit';

export const base: SepaDirectDebit = {
    enabled: false,
    _description: 'Enables Sepa Direct Debit feature',
    creditorMode: {
        enabled: false,
        _description: 'Enables refactored SEPA Direct Debit instead of the legacy one',
    },
};
